export default class lazyImage {
    constructor (element) {
        this.element = element
        this.LOADED_CLASS = 'loaded'
        if (this.element.classList.contains(this.LOADED_CLASS)) {
            return
        }
        if (this.element.complete) {
            this.handleImageLoad()
        } else {
            this.element.addEventListener('load', this.handleImageLoad.bind(this))
        }
    }

    handleImageLoad () {
        this.element.classList.add(this.LOADED_CLASS)
        this.element.removeEventListener('load', this.handleImageLoad.bind(this))
    }
}
